module.exports = __webpack_public_path__ + "img/doms.bf3072c6.png";